import React from "react";
import ContentWrapper from "../../live2/tc/ContentWrapper";
import DrawingTable from "../../live2/kp/ng/DrawingTable";
import ResultTable from "./ng/ResultTable";



const ResultTCNight = (props) => {
    const { result, config, image } = props;
    return <ContentWrapper isDef image={image} type={config.type} shift="ng">
        <DrawingTable {...props} />
        <ResultTable result={result} />
    </ContentWrapper>

}

export default ResultTCNight;